import React, { memo } from 'react';
import { Spinner } from './styled';

export const LoadingSpinner = memo(() => <Spinner />);
